<template>

    <div class="priceTotalHolder row">
        <!-- <div class="p-5 text-center w-100" v-if="getIsLoadingCalculations">
            <loader></loader>
        </div> -->
        <div v-if="reservation.billing" class="w-100">
            <div class="col-sm-12 bg-lighter py-2 border-bottom-light">

                <!-- TICKET PRICE -->
                <div class="darkest fs-small d-flex justify-content-between">
                    <span>Ticket Price</span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations.totalProductGrossprice)}} €</span>
                </div>

                <!-- EXTRAS -->
                <div class="darkest fs-small d-flex justify-content-between border-bottom-light pb-1 mb-1">
                    <span>Extras</span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else class="w-25 text-right">{{formatPrice(getReservationCalculations.totalComponentGrossprice)}} €</span>
                </div>

                <!-- DISCOUNT -->
                <div v-if="!reservation.attachPromocode" class="dark fs-small d-flex justify-content-between align-items-center align-items-center">
                    <span class="d-flex align-items-center" >Discount

                        <span class="px-1" v-if="!editingDiscount">{{reservation.attachDiscount.value}}{{(reservation.attachDiscount.valueType == 1)? '%' : '€'}}</span>

                        <span class="d-flex px-1" v-if="editingDiscount">
                            <input :disabled="disabled" type="number" class="glued-right px-2 py-0 text-center border-medium" style="width: 40px;" v-model="reservation.attachDiscount.value" placeholder="0" @input="overrideDiscountChanged" @focus="discountInputFocus">
                            <div class="glued-left w-25 py-0 px-1 pointer dark border-medium" style="width: auto !important;" @click="switchDiscountType" v-if="reservation.attachDiscount.valueType == 1">%</div>
                            <div class="glued-left w-25 py-0 px-1 pointer dark border-medium" style="width: auto !important;" @click="switchDiscountType" v-if="reservation.attachDiscount.valueType == 0">€</div>
                        </span>

                        <button :disabled="disabled" class="btn secondary tiny mr-1" v-if="editingDiscount" @click="applyingCustomDiscount">Apply</button>
                        <!-- <span class="fs-smaller bg-dark lightest radius-normal pointer px-1" v-if="!isReservationReadOnly || reservation.status == 5" @click="editingDiscountToogle">{{(editingDiscount)? 'Remove' : 'EDIT'}}</span> -->
                        <button :disabled="disabled" class="btn secondary tiny ml-1" v-if="!isReservationReadOnly || reservation.status == 5" @click="editingDiscountToogle">{{(editingDiscount)? 'Remove' : 'EDIT'}}</button>
                    </span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations.totalDiscounts)}} €</span>
                </div>

                <!-- REFUNDS -->
                <div class="darkest fs-small d-flex justify-content-between border-bottom-light pb-1 mb-1">
                    <span>Refunds</span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else class="w-25 text-right">{{formatPrice(getReservationCalculations.totalRefunds)}} €</span>
                </div>

                <!-- COMMISSIONS -->
                <div class="darkest fs-small d-flex justify-content-between align-items-center align-items-center">
                    <span class="d-flex align-items-center">
                        <span>Commission (total)</span>
                        <!-- Agent Promocode -->
                        <span v-if="reservation.attachPromocodeType == 1" class="bold ml-2">{{reservation.attachPromocode}} {{reservation.attachCommission.productValue}}{{(reservation.attachDiscount.valueType == 1)? '%' : '€'}}</span>
                    </span>

                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations.grandTotalCommission)}} €</span>
                </div>


                <!-- commissions editor -->
                <div class="dark fs-small d-flex justify-content-between align-items-center align-items-center" v-for="commissionType in comissionTypes" v-if="commissionType.active">
                    <span class="d-flex align-items-center ml-2">{{commissionType.label}}
                            <!-- <span class="px-1" v-if="!reservation.attachCommission['isToOverwrite'+commissionType.type] || !commissionType.editable">{{getReservationCalculations['entityCommissionTo'+commissionType.type+'Value']}}{{(getReservationCalculations['entityCommissionTo'+commissionType.type+'Type'] == 1)? '%' : '€'}}</span> -->
                            <span class="px-1" v-if="!isEditingCommissions[commissionType.type.toLowerCase()]">
                                <!-- {{getReservationCalculations['entityCommissionTo'+commissionType.type+'Value']}} -->
                                <!-- {{formatPrice(getReservationCalculations['total'+commissionType.type+'CommissionToEntityGrossprice'])}}
                                {{(getReservationCalculations['entityCommissionTo'+commissionType.type+'Type'] == 1)? '%' : '€'}} -->
                            </span>

                            <span class="d-flex px-1 align-items-center" v-else>
                                <input :disabled="disabled" type="number" class="glued-right px-2 py-0 text-center border-medium" style="width: 40px;" v-model="reservation.attachCommission[commissionType.type.toLowerCase()+'Value']" placeholder="0" @input="overrideCommissionChanged($event, commissionType.type.toLowerCase())">
                                <div class="glued-left w-25 py-0 px-1 pointer dark border-medium" style="width: auto !important;" @click="switchCommissionType(commissionType.type)" v-if="!reservation.attachCommission || reservation.attachCommission[commissionType.type.toLowerCase()+'ValueType'] == 1">%</div>
                                <div class="glued-left w-25 py-0 px-1 pointer dark border-medium" style="width: auto !important;" @click="switchCommissionType(commissionType.type)" v-if="reservation.attachCommission && reservation.attachCommission[commissionType.type.toLowerCase()+'ValueType'] == 0">€</div>
                                <button :disabled="disabled" class="btn secondary tiny mx-1" v-if="reservation.attachCommission['isToOverwrite'+commissionType.type]" @click="updateCommissions(commissionType)">Apply</button>
                            </span>
                            <button :disabled="disabled" class="btn secondary tiny" v-if="commissionType.editable && (!isReservationReadOnly || reservation.status == 5)" @click="editingCommissionToogle(commissionType.type)">{{(isEditingCommissions[commissionType.type.toLowerCase()])? 'Use default' : 'EDIT'}}</button>

                    </span>
                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations['total'+commissionType.type+'CommissionToEntityGrossprice'])}} €</span>
                </div>

                <!-- Tourist Promocode -->
                <div v-if="reservation.attachPromocode && reservation.attachPromocodeType == 0" class="fs-small d-flex justify-content-between align-items-center align-items-center">
                    <span class="d-flex align-items-center" >Promocode: <span class="bold ml-1">{{reservation.attachPromocode}}</span>

                        <span class="px-1 bold" >{{reservation.attachDiscount.value}}{{(reservation.attachDiscount.valueType == 1)? '%' : '€'}}</span>

                    </span>
                    <span>{{formatPrice(getReservationCalculations.totalDiscounts)}} €</span>
                </div>

                <!-- Total -->
                <div class="darkest fs-large font-weight-600 d-flex justify-content-between border-top-light mt-1">
                    <span>Total</span>
                    <span v-if="getIsLoadingCalculations"><loader size="big" opacity="0.2"></loader></span>
                    <span v-else class="pl-4">{{formatPrice(getReservationCalculations.grandTotal)}} €</span>
                </div>

            </div>

            <div class="col-sm-12 bg-darker radius-bottom-right-normal radius-bottom-left-normal areaTotal align-items-center d-flex flex-row ">
                <span v-if="getIsLoadingCalculations"><loader size="big" opacity="0.2"></loader></span>
                <div class="lightest fs-giant font-weight-600 d-flex justify-content-between align-items-center w-100 py-1" v-else-if="reservation.status != '-5'"><!-- -5 == Canceled -->
                    <span class="lightest bg-color-6 px-2 py-1 fs-normal radius-normal text-uppercase" :class="'bg-'+getPaymentState(0).color" v-if="roundPriceValue(totalDue) > 0">{{getPaymentState(0).label}}</span>
                    <span class="lightest bg-color-3 px-2 py-1 fs-normal radius-normal text-uppercase" :class="'bg-'+getPaymentState(1).color" v-if="roundPriceValue(totalDue) == 0">{{getPaymentState(1).label}}</span>
                    <span class="lightest bg-color-5 px-2 py-1 fs-normal radius-normal text-uppercase" :class="'bg-'+getPaymentState(2).color" v-if="roundPriceValue(totalDue) < 0">{{getPaymentState(2).label}}</span>
                    <span v-if="getIsLoadingCalculations"><loader size="big" opacity="0.2"></loader></span>
                    <span v-else-if="totalDue != 0">{{formatPrice(totalDue)}}€</span>
                </div>
                <div class="lightest fs-giant font-weight-600 d-flex justify-content-between align-items-center w-100 py-1" v-else-if="reservation.status == '-5'"><!-- -5 == Canceled -->
                    <span class="lightest px-2 py-1 fs-normal radius-normal text-uppercase" :class="'bg-'+getPaymentState(2).color" v-if="roundPriceValue(refundTotalMissing) > 0">{{getPaymentState(2).label}}</span>
                    <span class="lightest px-2 py-1 fs-normal radius-normal text-uppercase" :class="'bg-'+getPaymentState(4).color" v-if="roundPriceValue(refundTotalMissing) == 0">{{getPaymentState(4).label}}</span>
                    <span v-if="getIsLoadingCalculations"><loader size="big"></loader></span>
                    <span v-else-if="refundTotalMissing != 0">{{formatPrice(refundTotalMissing *-1 )}}€</span>
                </div>
            </div>
        </div>

        <div v-else class="dark text-center m-3 w-100">
            <div class="fs-large darker">Unable to load information</div>
        </div>

    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import {mapGetters, mapActions} from 'vuex'
import Loader from '@/tools/loaders/loader1'
export default {
    mixins: [reservationsMixin],
    data: function() {
        return {
            agentCommision: null,
            editingCommission: false,
            editingDiscount: false,
            comissionTypes:[
                {
                    type: 'Product',
                    label: 'Ticket',
                    active: true,
                    editable: true,
                },
                {
                    type: 'Component',
                    label: 'Extras',
                    active: true,
                    editable: true,
                },
                {
                    type: 'Transport',
                    label: 'Transport',
                    active: false,
                    editable: true,
                },
            ],
            isEditingCommissions: {
                ticket: false,
                extras: false,
                transport: false
            }
        }
    },
    created: function() {
        // sets attachDiscount valueType if none
        if(this.reservation.attachDiscount == null){
            this.$set(this.reservation, 'attachDiscount', {
                value: 0,
                valueType: 0
            })
        }

        this.getSelectedUserComissions()

    },
    computed: {
        ...mapGetters([
            'account',
            'getReservationCalculations',
            'getIsLoadingCalculations',
            'getPaymentState'
        ]),
        totalDue: function(){
            // return this.getReservationCalculations.grandTotal - this.paid
            return Math.round((this.getReservationCalculations.grandTotal - this.paid) * 100) / 100
        },
        refundTotalMissing: function () {
            return this.paid
        },
        isReservationInvoiced: function () {
            return this.reservation.bookingInvoices.length > 0 && this.reservation.bookingInvoices[this.reservation.bookingInvoices.length-1].invoiceType != 1
        }
    },
    methods: {
        ...mapActions([
            'setReservationCalculations'
        ]),
        switchDiscountType: function() {
            if(this.reservation.attachDiscount.valueType == 0){
                this.reservation.attachDiscount.valueType = 1
            } else {
                this.reservation.attachDiscount.valueType = 0
            }
            this.updateCalculations()
        },
        switchCommissionType: function(type) {
            //this.reservation.attachCommission[type+'ValueType'] = 1
            // for now commisions are only in %
            if(this.reservation.attachCommission[type.toLowerCase()+'ValueType'] == 0){
                this.reservation.attachCommission[type.toLowerCase()+'ValueType'] = 1
            } else {
                this.reservation.attachCommission[type.toLowerCase()+'ValueType'] = 0
            }
            this.updateCalculations()
        },
        getSelectedUserComissions: function(){
            if(this.reservation.creatorAgent && this.reservation.creatorAgent.id){
                axios.get('/api/people/GetAgentCommissions', {
                    params: {
                        supplierId: this.account.supplierId,
                        agentId: this.reservation.creatorAgent.id
                    }
                }).then(response => {
                    if(response.status && response.status == 200){
                        this.setAgentCommision(response.data)
                    }
                })
            }
        },
        setAgentCommision: function(commisions) {
            let agentCommision = commisions.defaultCommision

            for(let commisionRelation of commisions.commissionRelations){
                if(commisionRelation.productId == this.reservation.event.product.id){
                    agentCommision = commisionRelation.commissionValue;
                }
            }

            this.agentCommision = agentCommision
        },
        cannotChangeInvoicedWarning: function () {
            this.$dialog.alert('<h1>Booking is already invoiced.</h1> <p class="mt-3">You are not allowed to edit comissions or discounts of bookings that have been invoiced. Please check billing details in order to proceed with this.</p>', {okText: 'OK'})
            .then(function () {

            })
            .catch(function () {
            });
        },
        updateCommissions: function (commissionType){
            this.updateCalculations()
        },
        updateCalculations: function () {
            this.validateDiscount()
            return this.setReservationCalculations(this.reservation)
        },
        validateDiscount: function () {
            if(this.reservation.attachDiscount.valueType == 0){ // is €
                if(this.reservation.attachDiscount.value > this.getReservationCalculations.grandTotal){
                    this.reservation.attachDiscount.value = 0
                    this.$toasted.error('Discount is higher than total, please enter a new value');
                }
            } else { // is %
                if(this.reservation.attachDiscount.value > 100){
                    this.$toasted.error('Discount is higher than 100%, please enter a new value');
                    this.reservation.attachDiscount.value = 0
                }
                // this.reservation.attachDiscount.value = (this.reservation.attachDiscount.value > 100)? 0 : this.reservation.attachDiscount.value
            }
        },
        editingCommissionToogle: function(type) {
            if(this.isReservationInvoiced){
                this.cannotChangeInvoicedWarning()
                return false
            }

            this.isEditingCommissions[type.toLowerCase()] = !this.isEditingCommissions[type.toLowerCase()]
            if(this.isEditingCommissions[type.toLowerCase()]){
                //user clicked on edit
                this.reservation.attachCommission[type.toLowerCase()+'Value'] = this.reservation.attachCommission['default'+type+'Value']
                this.reservation.attachCommission[type.toLowerCase()+'ValueType'] = this.reservation.attachCommission['default'+type+'ValueType']
                this.updateCalculations()
            //     if(this.reservation.attachCommission && this.reservation.attachCommission.isToOverwriteProduct == true){
            //         this.reservation.attachCommission.isToOverwriteProduct == false
            //     } else {
            //         this.$set(this.reservation, 'attachCommission',{
            //             isToOverwriteProduct: true,
            //             ProductValueType: 1,
            //             ProductValue: this.getReservationCalculations.entityCommissionToProductValue,
            //             isToOverwriteProductComponent: true,
            //             ProductComponentValueType: 1,
            //             ProductComponentValue: 0,
            //         })
            //     }
            //
            //     this.editingCommission = true
            //
            } else {
                //user clicked on "use defaults"
                this.$set(this.reservation, 'attachCommission', {
                    isToOverwriteComponent: false,
                    isToOverwriteProduct: false,
                    isToOverwriteTransport: false
                })
                this.editingCommission = false
                this.updateCalculations().then(response => {
                    this.reservation.attachCommission = response.data.attachCommission
                });
            }

            return false // just exit

            // if(this.reservation.attachCommission['isToOverwrite'+type]){
            //
            //     this.updateCalculations()
            // } else {

            // }
            // this.reservation.attachCommission['isToOverwrite'+type] = !this.reservation.attachCommission['isToOverwrite'+type]

        },
        editingDiscountToogle: function() {
            if(this.isReservationInvoiced){
                this.cannotChangeInvoicedWarning()
                return false
            }

            if(this.editingDiscount){
                this.reservation.attachDiscount.value = 0;
                this.updateCalculations();
            }
            this.editingDiscount = !this.editingDiscount
        },
        overrideCommissionChanged: function(e, type) {
            //type can be: product, component, transport
            if(e.data == null) {
                //this.reservation.attachCommission.ProductValue = 0
            }
            // if(!this.reservation.attachCommission){
            //     this.$set(this.reservation, 'attachCommission',{
            //         isToOverwriteProduct: true,
            //         ProductValueType: 1,
            //         ProductValue: 0,
            //         isToOverwriteProductComponent: true,
            //         ProductComponentValueType: 1,
            //         ProductComponentValue: 0,
            //     })
            // }
            if(e.data == null) {
                this.reservation.attachCommission[type+'Value'] = null
            }
            this.reservation.attachCommission['isToOverwrite'+type+'Component'] = true
            this.reservation.attachCommission[type+'ComponentValueType'] = 1
            this.reservation.attachCommission[type+'ComponentValue'] = e.target.value
            // this.updateCalculations()
        },
        discountInputFocus: function () {
            if(this.reservation.attachDiscount.value == 0){
                this.reservation.attachDiscount.value = null
            }
        },
        overrideDiscountChanged: function(e) {
            // if(e.data == null) {
            //     //this.reservation.attachCommission.ProductValue = 0
            // }
            // if(!this.reservation.attachDiscount){
            //     this.$set(this.reservation, 'attachDiscount',{
            //         isToOverwriteProduct: true,
            //         ProductValueType: 1,
            //         ProductValue: 0,
            //         isToOverwriteProductComponent: true,
            //         ProductComponentValueType: 1,
            //         ProductComponentValue: 0,
            //     })
            // }
            // this.reservation.attachDiscount.ProductComponentValue = e.target.value
            // // this.updateCalculations()
        },
        applyingCustomDiscount: function () {

            if(this.reservation.attachDiscount.valueType == 1 && (this.reservation.attachDiscount.value > 100 || this.reservation.attachDiscount.value < 0)){
                this.$toasted.error('Discount must be between 0 and 100%');
                this.reservation.attachDiscount.value = 0
                return false
            }
            if(this.reservation.attachDiscount.valueType == 0 && this.reservation.attachDiscount.value < 0){
                this.$toasted.error('Discount must be higher than 0');
                this.reservation.attachDiscount.value = 0
                return false
            }

            // set updateFlag or else it will be ignored by API
            this.$set(this.reservation.updateFlags, 'discount', true)
            this.editingDiscount = false
            this.updateCalculations()
        }
    },
    props:{
        reservation: {
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Loader
    }
}
</script>

<style lang="scss" scoped>
.priceTotalHolder{
    min-height: 180px;
}

.areaTotal{
    height: 3.2rem;
}
</style>



// WEBPACK FOOTER //
// PriceTotal.vue?9f56a624